import { Routes } from '@angular/router';
import { navViewRoutes } from '@app/features/nav-view/nav-view.routing';
import { navAutomationRoutes } from '@app/features/nav-automation/nav-automation.routing'

export const featuresRoutes: Routes = [
    ...navViewRoutes,
    ...navAutomationRoutes
]